
import "@sparta.credit-cards.modules/category-choices-engagement-module/dist/styles.css"
import "@sparta.credit-cards.modules/category-choices-overview-module/dist/styles.css"
import "@sparta.credit-cards.modules/category-choices-categories-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import secureLinkUtility from "@sparta.global.utilities/secure-link-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"
import targetedContentBootstrapUtility from "@sparta.targeted-content.utilities/targeted-content-bootstrap-utility/dist/es6.js"
import spartaRegisterSwUtility from "@sparta.global.utilities/sparta-register-sw-utility/dist/es6.js"

import "@sparta.credit-cards.modules/category-choices-engagement-module/dist/es6.js"
import "@sparta.credit-cards.modules/category-choices-overview-module/dist/es6.js"
import "@sparta.credit-cards.modules/category-choices-categories-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [

  ],
}


// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
secureLinkUtility.run()
targetedContentBootstrapUtility.init();
spartaRegisterSwUtility.init();
  console.log('after - execute boot functions')
})();
